import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Caption } from 'components';

import { MedicalCardHotlineSectionContainer } from './styledComponents';

export interface MedicalCardHotlineSectionProps {
  generatedOn: string;
  serviceProviderHotline: string;
}

const MedicalCardHotlineSection: FC<MedicalCardHotlineSectionProps> = ({ generatedOn, serviceProviderHotline }) => {
  const { t } = useTranslation();

  return (
    <MedicalCardHotlineSectionContainer direction="vertical" size={0}>
      <Caption>{`${t('membershipCardDetail.emergencyHotlineDescription')} ${serviceProviderHotline}`}</Caption>
      <Caption>{t('membershipCardDetail.memberServiceHotline')}</Caption>
      {!!generatedOn && <Caption>{`${t('membershipCardDetail.generatedOn')} ${generatedOn}`}</Caption>}
    </MedicalCardHotlineSectionContainer>
  );
};

export default MedicalCardHotlineSection;
